import styled from 'styled-components';

export const Page = styled.div`
  padding: 0.85rem 1rem 1rem;
  background: ${({ theme }) => theme.colors.bgPrincipal};
  color: ${({ theme }) => theme.colors.txtPrincipal};
  display: flex; flex-direction: column;
  min-height: calc((100vh / var(--app-zoom, 1)) - 80px);
`;

export const Header = styled.div`
  display: flex; align-items: ${({ $alignItems }) => $alignItems || 'center'};
  justify-content: space-between;
  margin-bottom: 0.75rem; padding-bottom: 0.45rem;
  border-bottom: 1px solid ${({ theme }) => theme.colors.info};
`;

export const Title = styled.h1`
  color: ${({ theme }) => theme.colors.info}; font-size: 1.25rem;
  margin: 0; font-weight: 500; display: flex; align-items: center; gap: 0.45rem;
`;

export const Controls = styled.div`
  display: flex; gap: 0.6rem; align-items: center; margin-bottom: 0.75rem;
  flex-wrap: ${({ $wrap }) => $wrap ? 'wrap' : 'nowrap'};
`;

export const SearchInput = styled.input`
  background: ${({ theme }) => theme.colors.bgSecundario};
  border: 1px solid ${({ theme }) => theme.colors.borderDefault};
  color: ${({ theme }) => theme.colors.txtPrincipal};
  padding: 0.4rem 0.65rem; border-radius: 4px; font-size: 0.8rem;
  width: ${({ $width }) => $width || '240px'};
  &:focus { outline: none; border-color: ${({ theme }) => theme.colors.info}; }
  &::placeholder { color: ${({ theme }) => theme.colors.txtSecundario}; }
`;

export const BackBtn = styled.button`
  background: none; border: 1px solid ${({ theme }) => theme.colors.borderDefault};
  color: ${({ theme }) => theme.colors.txtSecondary}; border-radius: 4px;
  padding: 0.3rem 0.75rem; font-size: 0.8rem; cursor: pointer;
  display: flex; align-items: center; gap: 0.35rem;
  &:hover { border-color: ${({ theme }) => theme.colors.info}; color: ${({ theme }) => theme.colors.info}; }
`;

export const AddBtn = styled.button`
  background: ${({ theme }) => theme.colors.info};
  color: ${({ theme }) => theme.colors.onPrimary};
  border: none; padding: 0.45rem 0.9rem; border-radius: 4px;
  font-size: 0.8rem; font-weight: 500; cursor: pointer;
  display: flex; align-items: center; gap: 0.35rem;
  &:hover { background: ${({ theme }) => theme.colors.infoHover}; }
`;

export const TableWrap = styled.div`
  background: ${({ theme }) => theme.colors.bgSecundario};
  border: 1px solid ${({ theme }) => theme.colors.borderDefault};
  border-radius: 8px; overflow: hidden; flex: 1; overflow-y: auto;
  max-height: calc(
    (100vh / var(--app-zoom, 1))
    - ${({ theme }) => theme.heights.navbar}
    - ${({ theme }) => theme.heights.cintaOpciones}
    - ${({ theme }) => theme.heights.footer}
    - ${({ $offset }) => $offset || '165px'}
  );
`;

export const Table = styled.table`width: 100%; border-collapse: collapse;`;

export const Th = styled.th`
  padding: 0.5rem 0.65rem; text-align: left; font-weight: 600;
  color: ${({ theme }) => theme.colors.txtPrincipal};
  border-bottom: 2px solid ${({ theme }) => theme.colors.borderDefault};
  font-size: 0.8rem; background: ${({ theme }) => theme.colors.bgSecundario};
  position: sticky; top: 0; z-index: 1;
`;

export const Td = styled.td`
  padding: 0.55rem 0.75rem;
  border-bottom: 1px solid ${({ theme }) => theme.colors.borderDefault};
  font-size: 0.8rem;
`;

export const ActionsCell = styled(Td)`
  text-align: right; white-space: nowrap;
  & > * { opacity: 0; pointer-events: none; transition: opacity 0.15s; }
  tr:hover & > *, tr:focus-within & > * { opacity: 1; pointer-events: auto; }
`;

export const ActionBtn = styled.button`
  background: none;
  border: 1px solid ${({ $danger, theme }) => $danger ? theme.colors.danger : theme.colors.borderDefault};
  color: ${({ $danger, theme }) => $danger ? theme.colors.danger : theme.colors.txtSecundario};
  border-radius: 4px; padding: 3px 8px; font-size: 0.75rem; cursor: pointer; margin-left: 4px;
  &:hover { background: ${({ $danger, theme }) => $danger ? `${theme.colors.danger}20` : theme.colors.surfaceHover}; }
`;

export const Overlay = styled.div`
  position: fixed; inset: 0;
  background: ${({ theme }) => theme.colors.overlayBackdropStrong};
  display: flex; align-items: center; justify-content: center;
  z-index: ${({ theme }) => theme.zIndex.modal}; padding: 1rem;
`;

export const ModalBox = styled.div`
  background: ${({ theme }) => theme.colors.bgSecundario};
  border: 1px solid ${({ theme }) => theme.colors.borderDefault};
  border-radius: 8px; width: 100%;
  max-width: ${({ $maxWidth }) => $maxWidth || '540px'};
  display: flex; flex-direction: column;
  max-height: calc((100vh / var(--app-zoom, 1)) - 2rem);
`;

export const ModalHead = styled.div`
  display: flex; justify-content: space-between; align-items: center;
  padding: 0.75rem 1rem; border-bottom: 1px solid ${({ theme }) => theme.colors.info};
`;

export const ModalTitle = styled.h2`
  margin: 0; font-size: 1.1rem; font-weight: 500;
  color: ${({ theme }) => theme.colors.info};
`;

export const CloseBtn = styled.button`
  background: none; border: none; font-size: 1.4rem; cursor: pointer;
  color: ${({ theme }) => theme.colors.txtSecundario};
  &:hover { color: ${({ theme }) => theme.colors.danger}; }
`;

export const ModalBody = styled.div`padding: 1rem; overflow-y: auto; flex: 1;`;

export const ModalFoot = styled.div`
  display: flex; justify-content: flex-end; gap: 0.5rem;
  padding: 0.65rem 1rem; border-top: 1px solid ${({ theme }) => theme.colors.borderDefault};
  background: ${({ theme }) => theme.colors.bgSecundario};
`;

export const FormGrp = styled.div`margin-bottom: 0.85rem;`;

export const Lbl = styled.label`
  display: block; margin-bottom: 0.4rem; font-weight: 500; font-size: 0.9rem;
  color: ${({ theme }) => theme.colors.txtPrincipal};
`;

export const Inp = styled.input`
  width: 100%; background: ${({ theme }) => theme.colors.surface};
  border: 1px solid ${({ theme }) => theme.colors.borderDefault};
  color: ${({ theme }) => theme.colors.txtPrincipal};
  padding: 0.5rem 0.75rem; border-radius: 6px; font-size: 0.95rem;
  min-height: 34px; box-sizing: border-box;
  &:focus {
    outline: none; border-color: ${({ theme }) => theme.colors.info};
    box-shadow: 0 0 0 2px ${({ theme }) => `${theme.colors.info}33`};
  }
`;

export const Row2 = styled.div`display: grid; grid-template-columns: 1fr 1fr; gap: 0.75rem;`;

export const ErrMsg = styled.small`
  color: ${({ theme }) => theme.colors.danger}; margin-top: 2px; display: block;
`;

export const BtnPrimary = styled.button`
  background: ${({ theme }) => theme.colors.info}; color: ${({ theme }) => theme.colors.onPrimary};
  border: none; padding: 0.5rem 1.25rem; border-radius: 6px; font-size: 0.9rem; cursor: pointer;
  &:hover { background: ${({ theme }) => theme.colors.infoHover}; }
  &:disabled { opacity: 0.6; cursor: not-allowed; }
`;

export const BtnSecondary = styled.button`
  background: none; border: 1px solid ${({ theme }) => theme.colors.borderDefault};
  color: ${({ theme }) => theme.colors.txtPrincipal};
  padding: 0.5rem 1rem; border-radius: 6px; font-size: 0.9rem; cursor: pointer;
  &:hover { background: ${({ theme }) => theme.colors.surfaceHover}; }
`;

export const BtnDanger = styled.button`
  background: ${({ theme }) => theme.colors.danger}; color: ${({ theme }) => theme.colors.onPrimary};
  border: none; padding: 0.5rem 1.25rem; border-radius: 6px; font-size: 0.9rem; cursor: pointer;
  &:hover { background: ${({ theme }) => theme.colors.dangerHover}; }
`;
